import ButtonLarge from 'common/ButtonLarge';
import Heading from 'common/Heading';
import routes from 'config/routes';

import { useState } from 'react';



const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleForgotPassword = async () => {
    setError('');
    setMessage('');

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    try {
      const redirectUrl = `${process.env.REACT_APP_PROVIDER_PORTAL}${routes.auth.resetPassword}`;
      const encodedRedirectUrl = encodeURIComponent(redirectUrl);
      
      // Call backend API instead of Supabase directly
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/auth/v1/recover?redirect_to=${encodedRedirectUrl}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email.toLowerCase(),
            code_challenge: null,
            code_challenge_method: null,
            gotrue_meta_security: {},
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.error || errorData.message || 'Failed to send reset email';
        throw new Error(errorMessage);
      }

      setMessage('Password reset email sent! Please check your inbox.');
    } catch (err) {
      setError(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-5 items-center">
      <Heading className="text-center">Forgot Password</Heading>
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className={`common-input p-2.5 px-5 w-full focus:!bg-white ${
          error?.length > 0 ? 'error-field' : ''
        }`}
        autoFocus
      />
      <ButtonLarge
        className="w-full"
        loading={loading}
        disabled={!email}
        onClick={handleForgotPassword}
      >
        Send Reset Email
      </ButtonLarge>
      {error && !message && (
        <p className="text-red-500 text-sm font-medium text-center">{error}</p>
      )}
      {message && (
        <p className="text-green-500 text-sm font-medium text-center">
          {message}
        </p>
      )}
    </div>
  );
};

export default ForgotPassword;
